import { FeatureWellItem } from "./student-feature-well-item.model"
import { FeatureWellSearchCard } from "./student-feature-well-search-card.model"

export class StudentSearchFeatureWell {
    constructor(public item: FeatureWellItem, public searchCards: FeatureWellSearchCard[]) {}

    public static fromData(data): StudentSearchFeatureWell {
        // TODO: change after we have camel-case
        return new StudentSearchFeatureWell(
            FeatureWellItem.fromData(data.item),
            data.search_cards.map(FeatureWellSearchCard.fromData)
        )
    }
}
